var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(-13.8 69.35) rotate(-67.5)",
    fill: "#1ca1f1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.54,68.22c20.13,0,31.14-16.67,31.14-31.14,0-.47,0-.94,0-1.41A22.3,22.3,0,0,0,74.11,30a21.47,21.47,0,0,1-6.28,1.72,11,11,0,0,0,4.81-6,22.25,22.25,0,0,1-7,2.66,11,11,0,0,0-18.94,7.5A10.85,10.85,0,0,0,47,38.31,31.09,31.09,0,0,1,24.48,26.87a11,11,0,0,0,3.39,14.61,10.83,10.83,0,0,1-5-1.37v.14A11,11,0,0,0,31.68,51a10.74,10.74,0,0,1-2.87.39,11,11,0,0,1-2.07-.2A10.94,10.94,0,0,0,37,58.77a22,22,0,0,1-13.57,4.7h0a22.54,22.54,0,0,1-2.6-.16A31,31,0,0,0,37.5,68.22Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTwitter);
export default __webpack_public_path__ + "static/media/share-twitter.db3adf768a5b054501c475224028972e.svg";
export { ForwardRef as ReactComponent };